var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4694 7.7768H21.7301V6.62485H19.682V7.7768H12.834V6.62485H10.7859V7.7768H9.04665C7.84592 7.7768 6.86877 8.75376 6.86877 9.95468V24.031C6.86877 25.2318 7.84574 26.2089 9.04665 26.2089H23.4691C24.6698 26.2089 25.647 25.2319 25.647 24.031L25.6471 9.95468C25.6471 8.75376 24.67 7.7768 23.4693 7.7768H23.4694ZM14.769 23.993L10.6652 19.8889L12.1136 18.4411L14.8024 21.13L20.4197 15.7704L21.8337 17.2524L14.769 23.993ZM23.5992 12.5759H8.9171V9.955C8.9171 9.88357 8.97549 9.82518 9.04692 9.82518H10.7862V11.1691H12.8343V9.82518H19.6823V11.1691H21.7303V9.82518H23.4696C23.541 9.82518 23.5994 9.88357 23.5994 9.955L23.5992 12.5759Z",
    fill: "#00BC4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounEvent);
export default __webpack_public_path__ + "static/media/noun-event.b2e96e9cf5700cb1de0312a5ddc9ec5f.svg";
export { ForwardRef as ReactComponent };